import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { BILLING_PATH, PROFILE_PATH } from '@app/constants/navigation';
import { useBillingStatus, useNewUserAccessRights } from '@app/hooks';

// Реакция на BillingStatus === 'block' (филиал не оплачен):
// - админ/суперадмин уводится на страницу оплаты (/billing);
// - обычному сотруднику показывается заглушка на всех страницах, кроме
//   профиля (оплатить тариф он не может), навигация по разделам скрывается.
// Сменить филиал / профиль / помощь / выход остаются доступными в сайдбаре.
export const useBillingBlock = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { userAccessRights } = useNewUserAccessRights();
  const status = useBillingStatus();

  const isBlocked = status === 'block';
  const isAdmin = Boolean(
    userAccessRights?.IsAdmin || userAccessRights?.IsSuperAdmin
  );
  const isBlockedNonAdmin = isBlocked && !isAdmin;

  useEffect(() => {
    if (isBlocked && isAdmin && !pathname.startsWith(BILLING_PATH)) {
      navigate(BILLING_PATH);
    }
  }, [isBlocked, isAdmin, pathname, navigate]);

  return {
    // Скрыть навигацию по разделам в сайдбаре
    isBlockedNonAdmin,
    // Показать заглушку вместо контента страницы (профиль остаётся доступен)
    showBlockedStub: isBlockedNonAdmin && pathname !== PROFILE_PATH,
  };
};
